import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Page } from "../../../../components/page-base";
import theme from "../../../../styles/theme";
import useUserStore from "../../../../store/user";

const Wrapper = styled(Page.Root)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fdfefe;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  max-width: 720px;
  width: 100%;
  box-shadow: 0 6px 24px rgba(18, 38, 63, 0.06);
  text-align: center;
`;

const IconWrapper = styled.div`
  color: #1E8E3E;
  svg {
    font-size: 64px;
  }
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-family: var(--font-sans);
  font-size: 24px;
  color: #1F1F1F;
  margin: 8px 0 12px;
`;

const Subtitle = styled.p`
  font-family: var(--font-sans);
  color: #5f6368;
  margin-bottom: 24px;
`;

export const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();

  return (
    <Wrapper>
      <Card>
        <IconWrapper>
          <CheckCircleOutlineIcon />
        </IconWrapper>
        <Title>Pagamento realizado com sucesso!</Title>
        <Subtitle>
          Obrigado pela sua compra. Seu pedido foi processado com sucesso. Seu
          perfil será preparado em breve.
        </Subtitle>
        <div style={{ maxWidth: 320, margin: "0 auto" }}>
          <Page.Button
            label={user ? "Ir para Home" : "Ir para Login"}
            onClick={() => {
              if (user) {
                navigate("/home?payment=success");
              } else {
                navigate("/login");
              }
            }}
            hoverBgcolor={theme.colors.palete.greenHover}
            bgColor={theme.colors.palete.green}
          />
        </div>
      </Card>
    </Wrapper>
  );
};

export default PaymentSuccess;
